import { ToastPosition } from 'react-hot-toast';

// You can customize the template with the help of this file
// enum ThemeConfigSkin {
//   "LIGHT" = "light",
//   "DARK" = "dark",
//   "BORDERED" = "bordered",
//   "SEMI-DARK" = "semi-dark",
// }

export type ThemeConfigLayoutSkin = 'light' | 'dark' | 'bordered' | 'semi-dark';
export type ThemeConfigLayoutRouterTransition =
  | 'fadeIn'
  | 'fadeInLeft'
  | 'zoomIn'
  | 'none'
  | any;
export type ThemeConfigLayoutType = 'vertical' | 'horizontal' | 'blank';
export type ThemeConfigLayoutContentWidth = 'full' | 'boxed';
export type ThemeConfigLayoutNavbarType =
  | 'static'
  | 'sticky'
  | 'floating'
  | 'hidden';
export type ThemeConfigLayoutFooterType = 'static' | 'sticky' | 'hidden';

export interface ThemeConfigInterface {
  app: {
    appName: string;
    appLogoImage: string;
  };
  layout: {
    isRTL: boolean;
    skin: ThemeConfigLayoutSkin;
    routerTransition: ThemeConfigLayoutRouterTransition;
    type: ThemeConfigLayoutType;
    contentWidth: ThemeConfigLayoutContentWidth;
    menu: {
      isHidden: boolean;
      isCollapsed: boolean;
    };
    navbar: {
      type: ThemeConfigLayoutNavbarType;
      backgroundColor: string;
    };
    footer: {
      type: ThemeConfigLayoutFooterType;
    };
    customizer: boolean;
    scrollTop: true; // Enable scroll to top button
    toastPosition: ToastPosition;
  };
}

//Template config options
const themeConfig: ThemeConfigInterface = {
  app: {
    appName: 'CHARIS AD ADMIN',
    appLogoImage: require('@src/assets/images/logo/logo.svg').default,
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: 'top-right',
  },
};

export default themeConfig;
